import {
	removeConflictById,
	renumberAllChaptersPages,
	renumberAllInitialChaptersPages
} from '@editor2/services/conflictResolutionService';
import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { updateCourseChanges } from '../adapters/helpers';
import { getEntityResolver } from './common/entityResolver';

export const acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
	const resolver = getEntityResolver(conflict.entityType).getTypeResolver(conflict.conflictType);
	resolver.acceptBoth(state, conflict);

	removeConflictById(state, conflict.conflictId);

	// after all cleanup
	renumberAllChaptersPages(state);
	renumberAllInitialChaptersPages(state);
	updateCourseChanges(state);

	return state;
};
